var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MainServiceDisplayTabInvoices.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-07d814c4\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MainServiceDisplayTabInvoices.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/cost_splitting/MainServiceDisplayTabInvoices.vue
// module id = 1421
// module chunks = 4